// @ts-nocheck
/* eslint-disable */
import { CONFIG } from "~/config";
import { getReportPoiContextItem, getReportMapErrorContextItem, getReportAddFirmContextMenu } from "~/report/context-menu";
import { SMALL_MEDIA_QUERY } from "~/report/const";
import { _ } from "~/i18n";
import SceneProvider from "~/scene/provider";
import MapVisualiser from "~/scene/provider/map/visualiser";
import { default as SharePosition2 } from "./share-position2";
import SharePosition from "./share-position";
import { isDetailActive } from "~/util/detail";
import { store } from "~/state/store";
import { unsetDetail } from "~/state/detail/state";
import { setCoordinates } from "~/state/map/state";
import { detect } from "detect-browser";
import { openPanoramaAt } from "~/util/providers/pano";
import { handleClick } from "~/whereami";

const HISTORY_MOVE_CONST = 0.15;

export default class MapProvider extends SceneProvider {
	constructor(scene) {
		super(scene, MapVisualiser);

		this._map = null;
		this._signals = null;
		this._signalsList = [];
		this._scZoom = null;
		this._mapState = { coords: null, z: null }; /* pro overeni, jestli se pri map-redraw zmenil stav mapy */
		this._mapClickListener = null;
		this._contextMenu = null;
		this._panoAvail = null;
		this._pois = null;
		this._syncControl = null;
		this._sharePosition = null;
		this._ignoreZoomSignals = false;
	}

	/**
	 * Presenter pro 3d.
	 * @return {Melown3d}
	 */
	getMap() {
		return this._map;
	}

	/* *********************** interface *************************************** */

	handleEvent(e) {

		if (e.type == "resize") {
			this._syncControl.setBottomSpace(Mapy.Util.isSmallResolution() && !CONFIG.inFrame ? 48 : 0);
			if (this._map) {
				this._map.removeCard();
			}
		}
	}

	/**
	 * Bind signalu nad providerem - nabindujeme si vystup signalu na handleSignal.
	 *
	 * @param  {String} name Nazev signalu
	 */
	addListener(name) {
		let find = false;

		// jestlize jiz byl jednou nabindovan -> nic se nedeje
		for (let i = 0; i < this._signalsList.length; i++) {
			if (this._signalsList[i].name == name) {
				find = true;
				break;
			}
		}

		if (find) return;

		let id = this._signals.addListener(this, name, "handleSignal");

		this._signalsList.push({
			id: id,
			name: name
		});
	}

	/**
	 * Odstraneni poslouchani na nazev signalu - vola scena.
	 *
	 * @param  {String} name Nazev signalu
	 */
	removeListener(name) {
		for (let i = 0; i < this._signalsList.length; i++) {
			let item = this._signalsList[i];

			if (item.name == name) {
				this._signals.removeListener(item.id);
				this._signalsList.splice(i, 1);
				break;
			}
		}
	}

	/**
	 * Obsluha vsechn signalu, ktere po nas chtela scena.
	 * Nejdrive si zjistime predpis signalu ze sceny.
	 * Pokud signal vyzaduje nejake data - data klic, pripravime jej
	 * Pokud byl u eventu uvedeny sender, pokusime se najit jeho reprezentaci nad scenou.
	 *
	 * @param  {SMapEvent} e Udalost
	 */
	handleSignal(e) {
		let name = e.type;
		let signalData = this._scene.getSignal(name);

		if (!signalData) {
			// eslint-disable-next-line no-console
			console.error("Unknow signal " + name + "!");
			return;
		}

		let sendData = e.data || {};

		if (signalData.data) {
			signalData.data.forEach(key => {
				// data
				switch (name) {
					case "marker-drag-move":
					case "marker-drag-stop":
						if (key == "coords") {
							let smapCoords = e.target.getCoords().toWGS84();

							sendData[key] = this._scene.coordsFromWGS84(smapCoords[0], smapCoords[1]);
						}
						break;

					case "pano-availCheck":
						if (key == "avail") {
							sendData[key] = e.target.getAvail();
						}
						break;
				}
			});
		}

		this._scene.makeEvent(name, sendData, this._visualiser.getSceneItem(e.target));
	}

	/**
	 * Nastaveni callback funkce pro kliknuti do mapy.
	 *
	 * @param {Function} cb Callback funkce
	 */
	setMapClick(cb) {
		this._mapClickListener = cb;
	}

	/**
	 * Nastav kurzor provideru.
	 *
	 * @param {String} cursor Styl pro kurzor
	 */
	setCursor(cursor) {
		this._map.setCursor(cursor);
	}

	/**
	 * Ziskani objektu s paddingem - jak mapa, tak 3d
	 *
	 * @return {Object}
	 */
	getPadding() {
		let dirs = ["left", "right", "top", "bottom"];
		let output = {};

		dirs.forEach(dir => {
			output[dir] = this._map.getPadding(dir) || 0;
		});

		return output;
	}

	/**
	 * Ziskani DOMu pro obal vrstvy. Neda se bohuzel udelat jinak, pouziti pouze na starem userwebu!
	 *
	 * @return {Element}
	 */
	getLayerMarkerContainer() {
		return this._map.getLayerContainer(SMap.LAYER_MARKER);
	}

	/**
	 * Nastav stred projekce providera.
	 *
	 * @param {SceneCoords} center
	 */
	setCenter(center) {
		let smapCoords = this._visualiser.convertCoords(center);

		this._map.setCenter(smapCoords);
	}

	/**
	 * Nastav stred a zoom projekce providera.
	 *
	 * @param {SceneCoords} center
	 * @param {Number} [zoom] Volitelny zoom
	 * @param {Boolean} [noAnim = false] Neanimovat?
	 * @param {Object} options nasatveni zoomu
	 * @param {Object} options.maxAnimZoomPlus nasatveni maximalniho rozdilu pro animaci pri zvetsovani zoomu
	 * @param {Object} options.maxAnimZoomMinus nasatveni maximalniho rozdilu pro animaci pri zmensovani zoomu
	 * @return {JAK.Promise}
	 */
	setCenterZoom(center, zoom, noAnim, options) {
		let promise = new JAK.Promise();
		let mapZoom = this._map.getZoom();
		let zoomRange = this._map.getZoomRange();
		let opt = Object.assign({
			maxAnimZoomPlus: 2,
			maxAnimZoomMinus: 4,
		}, options);

		if (!zoom) { zoom = mapZoom; }
		if ( zoom > zoomRange[1] ) { zoom = zoomRange[1]; }
		if ( zoom < zoomRange[0] ) { zoom = zoomRange[0]; }

		let smapCoords = this._visualiser.convertCoords(center);
		let c = smapCoords;
		let port = this._map.getSize().norm();
		let zoomOk = false;

		/* zoomujeme max. 2 zoomy tam, max. 4 zoomy zpet nebo podle nastaveni options*/
		if (mapZoom > zoom && mapZoom - zoom <= opt.maxAnimZoomMinus) { zoomOk = true; }
		if (mapZoom < zoom && zoom - mapZoom <= opt.maxAnimZoomPlus) { zoomOk = true; }

		this._mapState.coords = c;
		this._mapState.z = zoom;
		this._ignoreZoomSignals = true;

		let printMode = Mapy.getComponent("print").mode;

		if (zoomOk && !noAnim && !printMode) {
			this._map.setCenterZoom(c, zoom, true);

			let signal = this._signals.addListener(null, "zoom-stop", () => {
				this._signals.removeListener(signal);

				let distance = this._map.getCenter().distance(c);

				// fix, pokud po animaci nesedi stredy, nastaveni pak jiz bez animace
				if (distance > 10) {
					this._map.setCenter(c, false);
				}

				promise.fulfill();
				this._ignoreZoomSignals = false;
			});
		} else if ((mapZoom == zoom && c.toPixel(this._map).norm() < 2*port) && !noAnim && !printMode) { /* stejny zoom, max. 2 uhlopricky */
			this._map.setCenter(c, true);

			let signal = this._signals.addListener(null, "center-stop", () => {
				this._signals.removeListener(signal);
				promise.fulfill();
				this._ignoreZoomSignals = false;
			});
		}
		else {
			this._map.setCenterZoom(c, zoom); // rovnou fulfill
			promise.fulfill();
			this._ignoreZoomSignals = false;
		}

		return promise;
	}

	/**
	 * Nastaveni rozsahu pro zoom.
	 *
	 * @param {Number} min
	 * @param {Number} max
	 */
	setZoomRange(min, max) {
		const { zoom } = store.getState().map;

		this._map.setZoomRange(min, max);

		if (zoom > max || zoom < min) {
			store.dispatch(setCoordinates({
				zoom: Math.min(Math.max(min, zoom), max),
				animate: true,
			}));
		}
	}

	/**
	 * Uzamknuti providera.
	 */
	lock() {
		this._map.lock();
	}

	/**
	 * Odemknuti providera.
	 */
	unlock() {
		this._map.unlock();
	}

	/**
	 * Znovu prepocet rozmery providera - roztahnuti do aktulniho kontentu.
	 */
	syncPort() {
		this._map.syncPort();
	}

	/**
	 * Prekresleni providera.
	 */
	redraw() {
		this._map.redraw();
	}

	/**
	 * Vyplneni kontext menu.
	 */
	fillContextMenu(e) {
		this._contextMenu.clearItems();

		let distanceMeterComp = Mapy.getComponent("distanceMeter");
		let userMarksComp = Mapy.getComponent("userMarks");

		if (distanceMeterComp.isActive()) {
			let items = distanceMeterComp.getContextMenuItems(e.data.event);

			items.forEach(i => {
				this._contextMenu.addItem(i);
			});
		}
		else if (userMarksComp.isActive()) {
			let userMarksLen = userMarksComp.getMain().getItems().length;

			this._contextMenu.addItem(Mapy.Util.createContextMenuItem(_("userMarks.clear"), userMarksLen, (e, menu) => {
				userMarksComp.getMain().removeAll();
				Mapy.getComponent("logger").log("points", { end_points: "clear", count: userMarksLen });
				e.stopPropagation();
				menu.close();
			}));
		}
		else {
			const routeItems = Mapy.getComponent("route").getContextItems();
			let routeItemsInd = 0;

			for (const routeItem of routeItems) {
				this._contextMenu.addItem(routeItem);
				routeItemsInd++;

				if (routeItemsInd === 2) {
					this._contextMenu.addItem(new SMap.Control.ContextMenu.Separator());
				}
			}

			this._contextMenu.addItem(new SMap.Control.ContextMenu.Separator());

			// pokud neni responsive
			if (!window.matchMedia(SMALL_MEDIA_QUERY).matches) {
				// pridat chybejici misto
				this._contextMenu.addItem(getReportPoiContextItem());
				// pridat firmu
				this._contextMenu.addItem(getReportAddFirmContextMenu());
				// chyba v mape
				this._contextMenu.addItem(getReportMapErrorContextItem());
				// separator
				this._contextMenu.addItem(new SMap.Control.ContextMenu.Separator());
			}

			this._contextMenu.addItem(Mapy.getComponent("userMarks").getContextItem());
			this._contextMenu.addItem(this._nearbySearchContextItem);
			this._contextMenu.addItem(this._whereamiContextItem);
		}

		return this._contextMenu;
	}

	/**
	 * Zavreni kontext menu.
	 */
	closeContextMenu() {
		this._contextMenu.close();
	}

	/**
	 * Ziskani controlu pro ovladani pomoci klavesnice - nepouzivat na widy!
	 */
	getKeyboardControl() {
		return this._map.getControls().filter(function(control) {
			return (control instanceof SMap.Control.Keyboard);
		})[0];
	}

	/**
	 * Ziskani controlu pro ovladani pomoci klavesnice - nepouzivat na widy!
	 */
	getMouseControl() {
		return this._map.getControls().filter(function(control) {
			return (control instanceof SMap.Control.Mouse);
		})[0];
	}

	getPanoDataUrl(pano) {
		return this._visualiser.getPanoDataUrl(pano);
	}

	reload() { return Promise.resolve(); }

	/**
	 * Aktivace provideru.
	 *
	 * @param  {Object} state Aktualni stav sceny
	 * @return {JAK.Promise}
	 */
	_activate(state) {
		let promise = new JAK.Promise();
		const { longitude, latitude, zoom, provider } = store.getState().map;

		this._mapState.coords = SMap.Coords.fromWGS84(longitude, latitude);
		this._mapState.z = zoom;

		let time = 0;

		if (!this._map) {
			// kontextove menu
			this._contextMenu = new Mapy.ContextMenu();

			/* contextove menu pro whereami*/
			this._whereamiContextItem = new Mapy.WhereAmI.ContextItem(_("whereAmI"));

			/* contextove menu pro hledani v okoli*/
			this._nearbySearchContextItem = new Mapy.Search.ContextItem(_("nearby"));

			// vytvoreni mapy, signalu
			this._buildMap(state);

			time = provider === "m3d" ? 500 : 0;
		} else {
			// zobrazime mapu
			this._map.getContainer().style.display = "";

			this._map.setCenterZoom(this._mapState.coords, this._mapState.z, false);

			if (state.zoomRange) {
				this.setZoomRange(state.zoomRange.min, state.zoomRange.max);
			}

			this._map.syncPort();
		}

		// sdileni polohy
		if (Mapy.CUS.userweb?.generalSharePosition) {
			this._sharePosition = new SharePosition2(this._map);
		} else {
			this._sharePosition = new SharePosition(this._map);
		}

		setTimeout(() => {
			promise.fulfill();
		}, time);

		return promise;
	}

	/**
	 * Deaktivace provideru.
	 *
	 * @return {JAK.Promise}
	 */
	_deactivate() {
		if (this._sharePosition) {
			this._sharePosition.destroy();
			this._sharePosition = null;
		}

		// odveseni posluchacu
		this._signalsList.forEach(item => {
			this._signals.removeListener(item.id);
		});

		this._signalsList = [];

		// kvuli prechodu do 3d jeste chvilku nechame mapu zobrazenou
		setTimeout(() => {
			// vycisteni vytvorenych dat
			this._visualiser.clear();

			// skryjeme mapu
			if (this._map) {
				this._map.getContainer().style.display = "none";
			} else {
				const container = document.getElementById("map");

				if (container) {
					container.style.display = "none";
				}
			}
		}, 500);
	}

	/**
	 * Prvotni vytvoreni mapy ze stavu sceny.
	 *
	 * @param  {Object} state Stav sceny
	 */
	_buildMap(state) {
		const browser = detect();
		let container = document.getElementById("map");

		container.innerHTML = "";

		if (container) {
			container.style.display = "";
		}

		// sentry
		if (typeof SMap._ === "undefined") {
			SMap._ = (value: string) => value;
			console.log(`Neexistuji prekladova fce z api.mapy`);
		}

		this._map = new SMap(container, this._mapState.coords, this._mapState.z, {
			minZoom:0,
			maxZoom:20,
			ophotoDate: false,
		});
		this._map.getLayerContainer(SMap.LAYER_TILE).classList.add("tiles");
		this._map.setPadding("top", 70);
		this._map.setPadding("bottom", 58);

		if (CONFIG.inFrame) {
			const urlParams = new URL(document.location.toString()).searchParams;

			if (urlParams.has("ol") && parseInt(urlParams.get("ol"))) {
				this._map.setPadding("left", 40);
				this._map.setPadding("right", 40);
			} else {
				this._map.setPadding("left", 24);
				this._map.setPadding("right", 24);
				this._map.setPadding("top", 20);
				this._map.setPadding("bottom", 42);
			}
		}
		else {
			this._map.setPadding("left", 12);
			this._map.setPadding("right", 12);
		}

		if (state.zoomRange) {
			this._map.setZoomRange(state.zoomRange.min, state.zoomRange.max);
		}

		this._signals = this._map.getSignals();
		this._buildMapControls();
		this._setMapSignals();
	}

	/**
	 * Vytvoreni ovladacich prvku nad mapou.
	 */
	_buildMapControls() {
		/* nahrazeni loga z API za vlastni logo pro tisk */
		var controls = this._map.getControls();

		for (var i = 0, len = controls.length; i < len; i++) {
			var control = controls[i];

			if (control instanceof SMap.Control.MapyLogo) {
				this._map.removeControl(control);
				control.$destructor();
			}
		}

		this._syncControl = new SMap.Control.Sync({ bottomSpace: Mapy.Util.isSmallResolution() && !CONFIG.inFrame ? 48 : 0 });
		this._map.addControl(this._syncControl);
		this._map.addControl(new SMap.Control.Mouse(SMap.MOUSE_PAN | SMap.MOUSE_WHEEL | SMap.MOUSE_ZOOM));
		this._map.addControl(new SMap.Control.Keyboard(SMap.KB_PAN | SMap.KB_ZOOM, { focusedOnly: false }));
		this._map.addControl(new SMap.Control.Selection(2));

		// smazeme def. copyright control
		const copyrightControl = this._map.getCopyrightControl();

		if (copyrightControl) {
			this._map.removeControl(copyrightControl);
		}

		if (!CONFIG.inFrame) {
			const { mapset } = store.getState().map;

			// control pro prepinai uzavirek redaktorem
			if (mapset === "uzavirky") {
				this._map.addControl(Mapy.getComponent("closureSwitch"), { top: "17px", right: "158px" });
			}

			this._map.addControl(this._contextMenu);

			this._signals.addListener(this, "map-contextmenu", "_openContextMenu");
		}

		window.addEventListener("resize", this, false);
	}

	/**
	 * Posluchace signalu pro mapu.
	 */
	_setMapSignals() {
		this._signals.addListener(this, "map-click", "_signalProxy");
		this._signals.addListener(this, "geometry-click", "_signalProxy");
		this._signals.addListener(this, "geometry-multi-click", "_signalProxy");
		this._signals.addListener(this, "marker-poi-click", "_signalProxy");
		this._signals.addListener(this, "marker-user-click", "_signalProxy");
		this._signals.addListener(this, "pano-available", "_panoAvailable");
		this._signals.addListener(this, "pano-unavailable", "_panoUnavailable");

		// poslouchani na udalosti controls pro ulozeni do historie
		this._signals.addListener(this, "control-keyboard-move", "_mapControlEvent");
		this._signals.addListener(this, "control-mouse-move", "_mapControlEvent");
		this._signals.addListener(this, "control-selection-centerzoom", "_mapControlEvent");
		this._signals.addListener(this, "zoom-start", "_zoom");
		this._signals.addListener(this, "zoom-stop", "_zoom");
	}

	/**
	 * Otevreni kontextove menu.
	*/
	_openContextMenu(e) {
		this.fillContextMenu(e).open(e.data.event);
	}

	/**
	 * Posloucha na nektere signaly z mapy a pokud je tomu situace naklonena, proxuje je do verejnych signalu
	 *
	 * @param {event} e DOM udalost
	 */
	_signalProxy(e) {
		let dome = e.data.event;

		if (e.type != "map-click") { dome.stopPropagation(); } /* pokud jsme klikli na neco nad mapou, nechceme uz signal o klikani do mapy */

		/* pokud mame zaregistrovaneho posluchace, hodime mu to */
		if (this._mapClickListener) {
			// pokud se jedna o klik na poi, predame poi jako druhy parametr
			if (e.type == "marker-poi-click") {
				this._mapClickListener.mapClick(dome, e.target, this._visualiser.getSceneItem(e.target));
			}
			else {
				this._mapClickListener.mapClick(dome, null);
			}
		/* pokud je aktivni routovac, predame klik na nej (kvuli pridavani dalsich cilu) */
		} else if (Mapy.getComponent("route").isActive() && (dome.ctrlKey || dome.metaKey)) {
			Mapy.getComponent("route").mapClick(dome);
		/* pokud na klik nikdo neposloucha, zkusime jestli to nesezere whereami */
		} else if (handleClick(dome)) {
			//
		/* klik na dostupne panorama ci 3d */
		} else if (e.type == "map-click") {
			this._panoFromEvent(dome);
		} else {
			// prekryti geometrie a panoramy
			if ((e.type == "geometry-multi-click" || e.type == "geometry-click") && this._panoFromEvent(dome)) return;

			// signaly: geometry-click, geometry-multi-click, marker-poi-click
			this._scene?.makeEvent(e.type, e.data, this._visualiser.getSceneItem(e.target));
		}
	}

	/**
	 * Vytvoreni pano z eventu - musi byt nastaven _panoAvail z click masky.
	 *
	 * @param  {Event} e
	 * @return {Boolean}
	 */
	_panoFromEvent(e) {
		if (this._panoAvail /*&& SMap.Pano.isSupported()*/) {
			const wgs84 = this._scene.coordsFromEvent(e).toWGS84();
			const zoom = store.getState().map.zoom;
			const selYear = Mapy.getComponent("pano").getYear();

			openPanoramaAt({
				lon: wgs84[0],
				lat: wgs84[1],
				zoom,
				selYear,
			}).then(() => {
				Mapy.getComponent("history")?.save();
			}, () => {});

			return true;
		}
		else {
			return false;
		}
	}

	_zoom(event) {
		if (this._ignoreZoomSignals) {
			return;
		}

		const { animating } = store.getState().map;

		if (animating && event.type === "zoom-stop") {
			const mm = this._countMapMove();
			const [longitude, latitude] = this._mapState.coords.toWGS84();

			if (this._active) {
				store.dispatch(setCoordinates({
					longitude,
					latitude,
					zoom: this._mapState.z,
					animating: false,
					ignore: true,
				}));
				Mapy.getComponent("history")?.save(mm);
			}
		} else if (!animating && event.type === "zoom-start") {
			if (this._active) {
				store.dispatch(setCoordinates({
					animating: true,
				}));
			}
		}
	}

	/**
	 * Event pri posunu stredu mapy pomoc klavesnice apod.
	 */
	_mapControlEvent(event) {
		if (this._active) {
			let mm = this._countMapMove();
			let wgs84 = this._mapState.coords.toWGS84();

			store.dispatch(setCoordinates({
				longitude: wgs84[0],
				latitude: wgs84[1],
				zoom: this._mapState.z,
				ignore: true,
			}));
			Mapy.getComponent("history")?.save(mm);
		}
	}

	/**
	 * Event pri zmene zoomu nad mapou.
	 */
	_mapControlEventZoom(event) {
		if (this._scZoom) { return; }

		this._scZoom = this._map.getSignals().addListener(this, "zoom-stop", () => {
			this._mapControlEvent(event);
			this._map.getSignals().removeListener(this._scZoom);

			this._scZoom = null;
		});
	}

	/**
	 * Spocitani kroku pri posunu mapy - ulozit do historie nebo ji prepsat?
	 *
	 * @return {Boolean}
	 */
	_countMapMove() {
		let center = this._map.getCenter();
		let zoom = this._map.getZoom();
		let replaceUrl = true;

		if (this._mapState && this._mapState.coords && (!center.equals(this._mapState.coords) || zoom != this._mapState.z)) {
			// vypocet posunu
			let pixel = this._mapState.coords.toPixel(this._map, zoom);
			let mapSize = this._map.getSize();
			let changeZoom = this._mapState.z != zoom;

			this._mapState.coords = center;
			this._mapState.z = zoom;

			// ulozime jen pokud byl posun od stredu vetsi nez nasobek velikosti strany konstantou HISTORY_MOVE_CONST a nebo pokud se zmenil zoom
			replaceUrl = !(changeZoom || mapSize.x*HISTORY_MOVE_CONST < Math.abs(pixel.x) || mapSize.y*HISTORY_MOVE_CONST < Math.abs(pixel.y));
		}

		return replaceUrl;
	}

	/**
	 * Signal pri dostupnosti panoramy.
	 */
	_panoAvailable() {
		if (this._panoAvail || this._mapClickListener) { return; }

		this._panoAvail = Mapy.Cursor.add({ cursor: "pointer" });
	}

	/**
	 * Signal pri nedostupnosti panoramy.
	 */
	_panoUnavailable() {
		if (!this._panoAvail) { return; }

		Mapy.Cursor.remove(this._panoAvail);
		this._panoAvail = null;
	}
}
